import * as types from '../constants'
import callAPI from '../callAPI/callAPI'

// get all
export const getAllProduct = (products) => {
    return {
        type: types.GET_ALL_PRODUCT_SUCCESS,
        payload: products
    }
}

export const fetchAPIALLProduct = () => {
    return dispatch => {
        return callAPI('products', 'GET', null).then(res => {
            dispatch(getAllProduct(res.data))
        })
    }
}

// get detail by id
export const getProductDetail = (product) => {
    return {
        type: types.GET_PRODUCT_DETAIL_SUCCESS,
        payload: product
    }
}

export const fetchAPIProductItem = (id) => {
    return dispatch => {
        return callAPI(`products/${id}`, 'GET', null).then(res => {
            dispatch(getProductDetail(res.data))
        })
    }
}

// add 
export const addProduct = (product) => {
    return {
        type: types.ADD_PRODUCT_SUCCESS,
        payload: product
    }
}

export const fetchAPIAddProduct = (product) => {
    return dispatch => {
        return callAPI('products', 'POST', product).then(res => {
            dispatch(addProduct(res.data))
            dispatch(fetchAPIALLProduct())
        })
    }
}

// edit

export const editProduct = (product) => {
    return {
        type: types.EDIT_PRODUCT_SUCCESS,
        payload: product
    }
}

export const fetchAPIEditProduct = (product) => {
    return dispatch => {
        return callAPI(`products/${product.id}`, 'PUT', product).then(res => {
            dispatch(editProduct(res.data))
            dispatch(fetchAPIALLProduct())
        })
    }
}

// delete

export const deleteProduct = (id) => {
    return {
        type: types.DELETE_PRODUCT_SUCCESS,
        payload: id
    }
}

export const fetchAPIDeleteProduct = (id) => {
    return dispatch => {
        return callAPI(`products/${id}`, 'DELETE', null).then(res => {
            dispatch(deleteProduct(id));
            dispatch(fetchAPIALLProduct())
        })
    }
}

// search

export const searchProduct = (products) => {
    return {
        type: types.SEARCH_PRODUCTS,
        payload: products
    }
}

export const fetchAPISearchProduct = (textSearch) => {
    return dispatch => {
        return callAPI(`products?search=${textSearch}`, 'GET', null).then(res => {
            dispatch(searchProduct(res.data));

        })
    }
}

// filter by name || category || price

export const filterValue = (filter) => {
    return {
        type: types.FILTER_VALUE,
        payload: filter
    }
}

// sort products

export const sortProducts = (sortValue) => {
    return {
        type: types.SORT_PRODUCTS,
        payload: sortValue
    }
}
